import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { Spinner, SpinnerSize, MessageBar, MessageBarType, PrimaryButton, Stack } from '@fluentui/react';
import { apiScopes } from './msalConfig';
import type { ReactNode } from 'react';

export default function AuthGuard({ children }: { children: ReactNode }) {
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{ scopes: apiScopes }}
      loadingComponent={Loading}
      errorComponent={AuthError}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
}

function Loading() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: 'var(--ab-bg-page)' }}>
      <Spinner size={SpinnerSize.large} label="Signing in…" />
    </div>
  );
}

function AuthError({ error }: { error: any }) {
  return (
    <Stack horizontalAlign="center" verticalAlign="center" styles={{ root: { height: '100vh', padding: 32, background: 'var(--ab-bg-page)' } }}>
      <MessageBar messageBarType={MessageBarType.error} styles={{ root: { maxWidth: 480 } }}>
        {error?.message || 'Something went wrong during sign-in.'}
      </MessageBar>
      <PrimaryButton text="Try again" onClick={() => window.location.reload()} styles={{ root: { marginTop: 16 } }} />
    </Stack>
  );
}
